import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  field_defs: {},
  html_nodes: [],
}

const processHtmlNodes = (htmlNodes) => {
  for (let item of htmlNodes) {
    const type = item.type
    if (type === 'question' && item.nodes.length > 0) item.asSubSection = true
    if (item.nodes && item.nodes.length > 0) processHtmlNodes(item.nodes)
  }
}

const fieldsSlice = createSlice({
  name: 'fields',
  initialState,
  reducers: {
    load(state, { payload: { field_defs, html_nodes } }) {
      processHtmlNodes(html_nodes)
      state.field_defs = field_defs
      state.html_nodes = html_nodes
    },
    addFieldDef(state, { payload: { key, value } }) {
      state.field_defs = { ...state.field_defs, [key]: value }
    },
    updateHtmlNodes(state, { payload: { html_nodes } }) {
      state.html_nodes = html_nodes
    },
  },
})

export const { load, addFieldDef, updateHtmlNodes } = fieldsSlice.actions
export default fieldsSlice.reducer
